<template>
    <div>
        <div>
            <div class="modal" tabindex="-1" id="confirmSafeWithdraw">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <h6 class="withdrawal-header">Withdrawal</h6>
                        <p>You have requested to withdraw money from your SAFE</p>
                    </div>
                    <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                        <button type="button" class="btn sheltaPrimaryBtn" @click="proceed()">Proceed</button>
                    </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" id="safeWithdrawal">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title modal-top">Withdrawal</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="amount">Amount</label>
                            <input v-model="withdrawalAmount" type="text" class="form-control" id="amount" placeholder="Amount">
                        </div>
                        <div class="form-group">
                            <label for="destination">Destination</label>
                            <select class="form-control" id="destination" v-model="accountId">
                                <option selected disabled value="">Select account</option>
                                <option :value="item" v-for="(item, index) in userAccounts" :key="index">{{item.bank_name}} - {{item.account_number}}</option>
                            </select>
                            <h6 class="mt-3" style="font-style: Lato; font-weight: 500; font-size: 14px; text-align: left;">{{ accountId.account_name }}</h6>
                        </div>
                    </div>
                    
                    <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                        <button :disabled="withdrawing" type="button" class="btn sheltaPrimaryBtn" @click="withdraFromSafe()">Withdraw
                            <span v-if="withdrawing"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                        </button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../store/service";
const Api = new Service();
import $ from "jquery";
export default {
    name: "SafeWithdrawal",
    props: {
    },
    data() {
        return {
            loading: false,
            withdrawing: false,
            userAccounts: [],
            accountId: "",
            withdrawalAmount: "",
            accountName: "",
        }
    },
    created() {
        this.$root.$refs.openConfirm = this;
    },
    mounted() {
        this.fetchUserAccount();
    },
    methods: {
        openConfirmModal() {
            $("#confirmSafeWithdraw")
            .addClass("fade")
            .modal("show");

            // $("#moneyConvertion")
            //     .removeClass("fade")
            //     .modal("hide");
            // }
        },
        proceed() {
            $("#confirmSafeWithdraw")
            .removeClass("fade")
            .modal("hide");

            $("#safeWithdrawal")
            .addClass("fade")
            .modal("show");
        },
        async fetchUserAccount() {
            await Api.getRequest(`fetch-user-validated-bank-account`)
            .then(data => {
                // console.log("bank Accounts", data)   
                if (data.data.success) {
                    this.userAccounts = data.data.banks;
                } else {
                    this.$toast.error(data.error);
                }
            }).catch((err) => {
                this.loading = false;
                console.log(err);
                // this.$toast.error("please check your network and refresh the page");
            });
        },
        async withdraFromSafe() {
           
           if (this.withdrawalAmount == '' || this.accountId == '') {
               return this.$store.commit("setApiFailed", "Fill all required fields");
           }
           this.withdrawing = true;
           try {
               await Api.postRequest(`fbn-payout`, {
                   amount: this.withdrawalAmount,
                   bank_account_id: this.accountId.id,
               })
               .then(res => {
                   this.withdrawing = false;
                //    console.log("Response withdrawal", res);
                   if (res.data.success) {
                       this.$store.commit("setApiSuccess", "Success");
                       $("#safeWithdrawal")
                        .removeClass("fade")
                        .modal("hide");
                        location.reload();
                        // this.$router.reload()
                   }
                   if (res.data.error){
                       this.$store.commit("setApiFailed", res.data.error);
                   }
   
                   // this.$store.commit("setApiSuccess", "Success");
               })
               .catch(err => {
                   this.withdrawing = false;
                   // console.log(err);
                   this.$store.commit("setApiFailed", "An error occured");
               });
           } finally {
               // console.log("Closed connection");
           }
       },
    },
}
</script>

<style scoped lang="scss">

.withdrawal-header {
    // margin-top: 10px;
    font-family: Lato;
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: #1F2937;

}

.modal-header  {
    border-bottom: none;
}
.modal-footer {
    border-top: none;
}

.sheltaPrimaryBtn {
    background: #0033EA;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    outline: 0;
    box-shadow: none;
}


.modal-top {
    font-family: Lato;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    color: #1F2937;

}

.form-group {
    label {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        color: #777777;
        text-align: left;
        display: flex;
    }
    input, select {
        border: 1px solid #BBBBBB;
        // color: #D1DBFF1A;
        height: 45px;
        color: #333333;
        font-family: Lato;
        font-weight: 600;
        font-size: 12px;
        box-shadow: none;
        outline: 0;
    }
}
</style>
